import React, { createContext, ReactNode, useState } from 'react';

interface AppContextProps {
  fetchDashboardData: boolean;
  fetchDashboardTrackingData: boolean;
  fetchAccountCommodity: boolean;
  showCommodityPopUpinDashboard:boolean;
  instantBidView:boolean;
  RefetchDashboardData: (newData: boolean) => void;
  RefetchDashboardTrackingData: (newData: boolean) => void;
  RefetchAccountCommodityData: (newData: boolean) => void;
  changeShowCommodityPopupinDashboard:(newData: boolean) => void;
  changeInstantBidview:(newData: boolean) => void;
}

const AppContext = createContext<AppContextProps>({
  fetchDashboardData: false,
  fetchDashboardTrackingData: false,
  fetchAccountCommodity: false,
  showCommodityPopUpinDashboard:true,
  instantBidView:false,
  RefetchDashboardData: () => {},
  RefetchDashboardTrackingData: () => {},
  RefetchAccountCommodityData: () => {},
  changeShowCommodityPopupinDashboard:()=>{},
  changeInstantBidview:()=>{},
});

interface AppProviderProps {
  children: ReactNode;
}

const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [fetchDashboardData, setRefetchDashboardData] = useState(false);
  const [fetchDashboardTrackingData, setfetchDashboardTrackingData] = useState(false);
  const [fetchAccountCommodity, setFetchAccountCommodityData] = useState(false);
  const [showCommodityPopUpinDashboard,setChangeShowCommodityPopupinDashboard]=useState(true);
  const [instantBidView ,setinstantbidview]= useState(false);


  const changeInstantBidview =(newData:boolean)=>{
    setinstantbidview(newData);
  };
  const RefetchDashboardData = (newData: boolean) => {
    setRefetchDashboardData(newData);
  };
  const RefetchDashboardTrackingData = (newData: boolean) => {
    setfetchDashboardTrackingData(newData);
  };
  const RefetchAccountCommodityData = (newData: boolean) => {
    setFetchAccountCommodityData(newData);
  };

  const changeShowCommodityPopupinDashboard = (newData: boolean) => {
    setChangeShowCommodityPopupinDashboard(newData);
  };
  return (
    <AppContext.Provider
      value={{
        fetchDashboardData,
        fetchDashboardTrackingData,
        fetchAccountCommodity,
        showCommodityPopUpinDashboard,
        instantBidView,
        RefetchDashboardData,
        RefetchDashboardTrackingData,
        RefetchAccountCommodityData,
        changeShowCommodityPopupinDashboard,
        changeInstantBidview,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export { AppProvider, AppContext };
